import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const LOGOUT_MUTATION = gql`
  mutation LogoutMutation { logout }
`;

@Injectable({
  providedIn: 'root'
})
export class LogoutMutation extends Mutation<RootMutation> {
  document = LOGOUT_MUTATION;
}
